'use strict';

/**
 * toggle
 */
export const toggle = (() => {
    const init = () => {
        const $toggle = $('.js-trigger-toggle');

        $toggle.each((index, element) => {
            const $this = $(element);
            $this.on('click', event => {
                scroll($this);

                $this.toggleClass('is-close');
                $this.prev('.js-target-toggle').slideToggle(600, 'swing');

                if ($this.hasClass('is-close') === true) {
                    $this.children('span').text('詳細を見る');
                } else {
                    $this.children('span').text('閉じる');
                }
            });
        });
    };

    const scroll = e => {
        const speed = 600;
        const href = e.attr('toggle-id');
        const target = $('#toggle' + href);
        const position = target.offset().top * 0.95;

        if ($(window).scrollTop() + $(window).height() > position && e.hasClass('is-close')) {
            $('html, body').animate({ scrollTop: position }, speed, 'swing');
        }
    };

    return {
        init: init
    };
})();
